"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { ListClickEvents } from "@jti/ui/components/List/types";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

// TODO: After running migration, remove LegacyListStyles and map to ListStyles
export enum LegacyListStyles {
  Standard = "standard",
  // Maps to standard
  RelatedResources = "related-resources",
  BlueLinks = "blue-links",
  // Maps to quick-links
  Arrow = "arrow",
  // Footer completely not used but kept just in case and maps to navigation
  Footer = "footer",
  // Maps to navigation
  Navigation = "navigation",
  // Maps to navigation-horizontal
  HorizontalArrows = "horizontal-arrows",
}

const LinksList = dynamic(async () =>
  withValidation(linksListInputs, (await import("./LinksList")).LinksList, "LinksList")
);

export const linksListInputs = [
  {
    name: "title",
    type: "string",
  },
  {
    name: "style",
    type: "string",
    defaultValue: "blue-links",
    enum: Object.values(LegacyListStyles),
    required: true,
  },
  {
    name: "listClickEvent",
    type: "string",
    defaultValue: "list_click",
    enum: Object.values(ListClickEvents),
    required: true,
  },
  {
    name: "enableCookieSettings",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "listItems",
    type: "list",
    required: true,
    defaultValue: [
      {
        title: "First link",
        path: "/",
        tabBehaviour: "sameTab",
      },
      {
        title: "Second link",
        path: "/",
        tabBehaviour: "sameTab",
      },
      {
        title: "Third link",
        path: "/",
        tabBehaviour: "sameTab",
      },
    ],
    subFields: [
      {
        name: "title",
        type: "string",
        defaultValue: "Link",
        required: true,
      },
      {
        name: "path",
        type: "url",
        defaultValue: "/",
        required: true,
      },
      {
        name: "tabBehaviour",
        type: "string",
        defaultValue: "sameTab",
        enum: ["sameTab", "newTab"],
        required: true,
      },
    ],
  },
] as const satisfies Inputs;

export const LinksListComponent: RegisteredComponent = {
  name: "LinksList",
  component: LinksList,
  inputs: linksListInputs,
};
